import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import selectors from './ClinicSelectors';

const onShowSort = () => {
	disableBodyScroll(selectors.ELEMENTS.mobileSort);

	/**
	 * `timeout` is `null` so that animation can start immediately in the next event cycle(when other elements are rendered)
	 */
	setTimeout(() => {
		// class for button animation
		selectors.ELEMENTS.hideSort.classList.add(selectors.CLASSES.active);
	}, null);

	selectors.ELEMENTS.navigation.classList.add(selectors.CLASSES.displayNone);
	// sort
	selectors.ELEMENTS.mobileSort.classList.add(selectors.CLASSES.active);
	// options
	selectors.ELEMENTS.showFilters.classList.add(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.showSort.classList.add(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.hideSortContainer.classList.remove(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.hideSort.classList.remove(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.clearSort.classList.remove(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.saveSort.classList.remove(selectors.CLASSES.displayNone);
	// info
	selectors.ELEMENTS.infoFilters.classList.add(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.labelSort.classList.remove(selectors.CLASSES.displayNone);
	// breadcrumb
	selectors.ELEMENTS.breadcrumb.classList.add(selectors.CLASSES.displayNone);
	// search toggle
	selectors.ELEMENTS.searchBtnTrigger.classList.add(selectors.CLASSES.displayNone);
	// search form
	selectors.ELEMENTS.searchForm.classList.add(selectors.CLASSES.displayNone);
};

const onHideSort = () => {
	enableBodyScroll(selectors.ELEMENTS.mobileSort);
	// animated element
	selectors.ELEMENTS.hideSort.classList.remove(selectors.CLASSES.active);
	// when animation is done, handle other elements
};

const helperOnHideSort = () => {
	selectors.ELEMENTS.navigation.classList.remove(selectors.CLASSES.displayNone);
	// sort
	selectors.ELEMENTS.mobileSort.classList.remove(selectors.CLASSES.active);
	// options
	selectors.ELEMENTS.showSort.classList.remove(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.hideSortContainer.classList.add(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.hideSort.classList.add(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.clearSort.classList.add(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.saveSort.classList.add(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.showFilters.classList.remove(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.clearFilters.classList.add(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.saveFilters.classList.add(selectors.CLASSES.displayNone);
	// info
	selectors.ELEMENTS.infoFilters.classList.remove(selectors.CLASSES.displayNone);
	selectors.ELEMENTS.labelSort.classList.add(selectors.CLASSES.displayNone);
	// breadcrumb
	selectors.ELEMENTS.breadcrumb.classList.remove(selectors.CLASSES.displayNone);
	// search toggle
	selectors.ELEMENTS.searchBtnTrigger.classList.remove(selectors.CLASSES.displayNone);
	// search form
	selectors.ELEMENTS.searchForm.classList.remove(selectors.CLASSES.displayNone);
};

export default {
	onShowSort,
	onHideSort,
	helperOnHideSort,
};
